import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Alert } from "react-bootstrap";
import { API_BASE_URL } from "../Config";
import { useTranslation } from 'react-i18next';

function getCsrfToken() {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  console.log("CSRF Token não encontrado");
  return null;
}

function PreviousPurchasesScreen() {
  const { t, i18n } = useTranslation();
  const [purchases, setPurchases] = useState([]);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchPurchases = async () => {
      const clientId = localStorage.getItem("clientId");
      const csrfToken = getCsrfToken();
      console.log("CSRF Token:", csrfToken);
      console.log("Client ID recuperado do localStorage:", clientId);

      if (clientId && csrfToken) {
        try {
          const response = await fetch(`${API_BASE_URL}/api/previous-purchases/${clientId}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': csrfToken,
            },
            credentials: 'include'
          });

          console.log("Fetching data from: ", `${API_BASE_URL}/api/previous-purchases/${clientId}/`);
          if (!response.ok) {
            throw new Error("Erro ao buscar compras anteriores do cliente.");
          }
          const data = await response.json();
          
          // Converter as datas em objetos Date
          const purchasesWithDate = data.map(purchase => ({
            ...purchase,
            date: new Date(purchase.date)
          }));
          
          console.log("Previous purchases fetched: ", purchasesWithDate);
          setPurchases(purchasesWithDate);
        } catch (error) {
          console.error("Erro ao buscar compras anteriores do cliente:", error);
          setShowError(true);
          setErrorMessage("Erro ao buscar compras anteriores do cliente.");
        }
      } else {
        setShowError(true);
        setErrorMessage("ID do cliente ou CSRF Token não encontrado.");
      }
    };

    fetchPurchases();
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString(i18n.language, { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <Container className="pt-4">
      <Row>
        <Col sm={12} className="m-auto">
          <h3 className="pb-md-1">{t('previous_purchases')}</h3>
          {showError && (
            <Alert variant="danger">
              {errorMessage}
            </Alert>
          )}
          {purchases.length === 0 ? (
            <Alert variant="info">{t('no_purchases_message')}</Alert>
          ) : (
            <>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{t('date')}</th>
                    <th>{t('products')}</th>
                    <th>{t('status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.map((purchase, index) => (
                    <tr key={index}>
                      <td>{formatDate(purchase.date)}</td>
                      <td>
                        {purchase.items.map((item, itemIndex) => (
                          <div key={itemIndex}>
                            {item.productName} - {item.quantity}x - {item.price.toFixed(2)}€
                          </div>
                        ))}
                      </td>
                      <td>{purchase.orderDelivered ? t('obs_delivered') : t('not_delivered')}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default PreviousPurchasesScreen;
